<template>
  <div>
    <b-card>
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Purchase ID"
              label-for="purchaseId"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <b-form-input
                id="purchaseId"
                v-model="purchaseId"
                placeholder="Purchase ID"
              />
            </b-form-group>
            <b-form-group
              label="User"
              label-for="username"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <b-form-input
                id="username"
                v-model="username"
                placeholder="User"
              />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="payments"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_payment')"
        :per-page="0"
      >
        <template #cell(type)="row">
          {{ getPaymentType(row.item.type) }}
        </template>
        <template #cell(os)="row">
          {{ getOS(row.item.os) }}
        </template>
        <template #cell(created_by_data)="row">
          {{
            row.item.created_by_data ? row.item.created_by_data.username : ""
          }}
        </template>
        <template #cell(created_at)="row">
          {{ row.item.created_at ? getDateTime(row.item.created_at) : "" }}
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import util from "@/util.js";

export default {
  components: {
    VueSelectPaginated,
  },
  data() {
    return {
      fields: [
        { key: "purchase_id", label: "Purchase Id" },
        { key: "title", label: "Title" },
        { key: "price", label: "Price" },
        { key: "type", label: "Type" },
        { key: "os", label: "OS" },
        { key: "created_by_data", label: "User" },
        { key: "created_at" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      payments: [],
      payment: null,
      searchTypes: [
        { value: 1, name: "Purchase ID" },
        { value: 2, name: "User" },
      ],
      searchType: null,
      purchaseId: "",
      username: "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
  },
  methods: {
    ...mapActions({
      getPayments: "appData/getPayments",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.username = "";
            break;
          case 2:
            this.purchaseId = "";
            break;
        }
      } else {
        this.purchaseId = "";
        this.username = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getPayments({
          pageNumber: this.currentPage,
          purchase_id: this.purchaseId,
          created_by_username: this.username,
        });
        this.payments = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
